<template>
    <ideo-form-group>
        <ideo-form-checkbox v-model="form.settings.nameIsVisible">
            {{ $t('[[[Wyświetlaj nazwę bloczka]]]') }}
        </ideo-form-checkbox>
    </ideo-form-group>
    <ideo-form-group :label="$t('[[[Wybór listy stron]]]')" :invalid-feedback="form.$errors.first('settings.pages')" :state="form.$errors.state('settings.pages')" required>
        <multiselect
            v-model="form.settings.pages"
            label="text"
            track-by="value"
            :options="selectedPageOptions"
            :multiple="true"
            :placeholder="$t('[[[Wybierz strony]]]')"
        >
            <template #noOptions>{{ $t('[[[Lista jest pusta]]]') }}</template>
            <template #noResult>{{ $t('[[[Nie znaleziono żadnych wyników.]]]') }}</template>
        </multiselect>
    </ideo-form-group>
    <ideo-form-group :label="$t('[[[Wybór strony przekierowującej]]]')" :invalid-feedback="form.$errors.first('settings.redirectPage')" :state="form.$errors.state('settings.redirectPage')">
        <multiselect
            v-model="form.settings.redirectPage"
            label="text"
            track-by="value"
            :options="selectedPageOptions"
            :multiple="false"
            :placeholder="$t('[[[Wybierz stronę]]]')"
        >
            <template #noOptions>{{ $t('[[[Lista jest pusta]]]') }}</template>
            <template #noResult>{{ $t('[[[Nie znaleziono żadnych wyników.]]]') }}</template>
        </multiselect>
        <template #description>
            <span>{{ $t('[[[Przycisk "zobacz wszystkie" znajdujący się przy bloczku, będzie przekierowywał na wybraną stronę z szkoleniami. Jeśli strona nie zostanie wybrana zostanie on ukryty.]]]') }}</span>
        </template>
    </ideo-form-group>
    <ideo-form-group :label="$t('[[[Liczba wyświetlanych produktów]]]')" :invalid-feedback="form.$errors.first('settings.amount')" :state="form.$errors.state('settings.amount')">
        <ideo-form-select name="settings.amount" v-model="form.settings.amount" :options="amount"></ideo-form-select>
    </ideo-form-group>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from '@/helpers/Decorators';
import { CurrentWebsite, Option } from '@/helpers/Interfaces';
import { FormType } from '@/helpers/Form';
import merge from 'lodash/merge';
import { wait } from '@/helpers/Utils';
import PagesService, { PageListItemModel } from '@/modules/cms/pages/services/PagesService';
import Multiselect from 'vue-multiselect/src/Multiselect.vue';
import { useWebsitesStore } from '@/modules/cms/websites/store';

interface FormSettings
{
    settings: any;
}

@Options({
    name: 'widget-productslist-settings',
    components: {
        'multiselect': Multiselect
    }
})
export default class ProductsListSettings extends Vue
{
    @Prop() public modelValue!: any;

    public get form(): FormType<FormSettings>
    {
        return this.modelValue;
    }

    public module: string = 'shop_products';
    public defaults: any = {
        pages: [],
        redirectPage: null,
        amount: 10,
        nameIsVisible: true,
    };

    public pageOptions: PageListItemModel[] = [];

    public get current(): CurrentWebsite
    {
        return useWebsitesStore().current;
    }

    public get selectedPageOptions(): Option[]
    {
        return this.pageOptions.map(p =>
        {
            return { value: p.id.toString(), text: p.option };
        });
    }

    public get amount(): Option<number>[]
    {
        return new Array(10).fill(null).map((value, index) =>
        {
            return { value: index + 1, text: (index + 1).toString() };
        });
    }

    public async created(): Promise<void>
    {
        await wait(() => this.current.website);
        await this.loadPages();
        this.form.settings = merge(this.defaults, this.form.settings);
    }

    @Watch('form.settings', { deep: true })
    public onSettingsChanged(value: any): void
    {
        this.triggetModel();
    }

    @Emit('update:modelValue')
    public triggetModel(): any
    {
        return this.form;
    }

    public async loadPages(): Promise<void>
    {
        try
        {
            this.pageOptions = await PagesService.getPagesByModule(this.current.website, this.current.locale, this.module);
            this.pageOptions = this.pageOptions.filter(x => x.id != 0);
        }
        catch (ex)
        {
            this.pageOptions = [];
            this.$log.debug(ex);
        }
    }
}
</script>
